import React from 'react';
export function Footer() {
  return <footer className="border-t border-sage/30 bg-cream-dark px-4 py-6" data-id="element-66" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl space-y-2 text-center text-xs leading-snug text-graphite/80" data-id="element-67" data-mp="3ggaqfufcyb4x">
        <p className="font-semibold text-petrol" data-id="element-68" data-mp="32ovz90bar3ms">
          © 2026 LOGOPEDIA PRO™ — Tutti i Diritti Riservati.
        </p>
        <p data-id="element-69" data-mp="36ppktn19o6ci">
          Le informazioni e i materiali contenuti in questo sistema sono risorse professionali di
          supporto destinate a logopedisti qualificati. Non sostituiscono la formazione
          professionale, la valutazione individuale, il giudizio clinico o la responsabilità del
          professionista. Ogni attività, sessione, obiettivo, progressione o materiale deve essere
          selezionato e adattato alle caratteristiche, alle necessità e agli obiettivi individuali
          del paziente.
        </p>
        <p data-id="element-70" data-mp="2ey9zdwbg4pnv">
          <a href="mailto:kitonline27@gmail.com" className="font-semibold text-petrol underline" data-id="element-71" data-mp="2ey0ayd61uqka">
            kitonline27@gmail.com
          </a>
        </p>
        <p data-id="element-72" data-mp="3l9shh1e8ymmw">Termini e Condizioni • Privacy Policy • Contatti</p>
      </div>
    </footer>;
}